// ************
// Recipe Single View
// Difficulty Information
// with
// Schwierigkeitsgrad and Cooking Time
// ************
import BackgroundBubbles from "@/components/BackgroundBubbles/BackgroundBubbles";
import { RecipeType } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";
import { ReactSVG } from "react-svg";
import styles from "./RecipeDifficultyInfo.module.scss";

interface RecipeDifficultyInfoProps {
  recipeDetails: RecipeType;
}

export const CookingIcons = ({ src }: { src: string }) => {
  return (
    <ReactSVG
      src={src}
      width={24}
      height={24}
      wrapper="svg"
      beforeInjection={(svg) => {
        svg.setAttribute("width", "24");
        svg.setAttribute("height", "24");
        svg.setAttribute("aria-hidden", "true");
        svg.setAttribute("focusable", "false");
      }}
      className={`${styles["cooking-icon"]}`}
    />
  );
};

function RecipeDifficultyInfo({ recipeDetails }: RecipeDifficultyInfoProps) {
  const { getLabel, getIcon } = useGlobalContext();
  const {
    zeit_backen,
    zeit_kochen,
    zeit_kuehlen,
    zeit_ruhen,
    zeit_tiefkuehlen,
    zubereitungszeit,
    schwierigkeitsgrad,
    umluft,
  } = recipeDetails;
  let cookingTimeJSX,
    prepareTimeJSX,
    bakingTimeJSX,
    coolingTimeJSX,
    restingTimeJSX,
    freezingTimeJSX,
    completeTimeJSX;
  const totalTime = zubereitungszeit;
  const prepareTime =
    zubereitungszeit -
    (zeit_kochen + zeit_backen + zeit_kuehlen + zeit_ruhen + zeit_tiefkuehlen);

  if (prepareTime) {
    prepareTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("prepareTime")} />
        {getLabel("prepare_time")}
        <span className={`${styles.time}`}>{prepareTime}</span>
        min
      </p>
    );
  }
  if (zeit_kochen) {
    cookingTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("cookingtime")} />
        {getLabel("cooking_time")}
        <span className={`${styles.time}`}>{zeit_kochen}</span>
        min
      </p>
    );
  }
  if (zeit_backen) {
    bakingTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon(umluft ? "umluft" : "oberunterhitze")} />
        {getLabel(
          umluft ? "recipe_label_umluft" : "recipe_label_ober_unterhitze",
        )}
        <span className={`${styles.time}`}>{zeit_backen}</span>
        min
      </p>
    );
  }
  if (zeit_kuehlen) {
    coolingTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("coolingTime")} />
        {getLabel("cooling_time")}
        <span className={`${styles.time}`}>{zeit_kuehlen}</span>
        min
      </p>
    );
  }
  if (zeit_ruhen) {
    restingTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("restingTime")} />
        {getLabel("resting_time")}
        <span className={`${styles.time}`}>{zeit_ruhen}</span>
        min
      </p>
    );
  }
  if (zeit_tiefkuehlen) {
    freezingTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("freezingTime")} />
        {getLabel("freezing_time")}
        <span className={`${styles.time}`}>{zeit_tiefkuehlen}</span>
        min
      </p>
    );
  }

  // const completeTime =
  //   zubereitungszeit +
  //   zeit_kochen +
  //   zeit_backen +
  //   zeit_kuehlen +
  //   zeit_ruhen +
  //   zeit_tiefkuehlen;
  if (totalTime) {
    completeTimeJSX = (
      <p className={`${styles["cooking-information-element"]}`}>
        <CookingIcons src={getIcon("completeTime")} />
        {getLabel("complete_time")}
        <span className={`${styles.time}`}>{totalTime}</span>min
      </p>
    );
  }
  return (
    <section
      className={`is-relative has-box-shadow ${styles["recipe-difficulty-info"]}`}
    >
      <BackgroundBubbles topLeft={false} />
      <div className={`${styles.level}`}>
        <p>{getLabel(`label_schwierigkeitsgrad_${schwierigkeitsgrad}`)}</p>
        {Array.from({ length: 3 }, (_, index) => (
          <ReactSVG
            key={index}
            src={getIcon(`levelCategory`)}
            width={22}
            height={22}
            wrapper="svg"
            beforeInjection={(svg) => {
              svg.setAttribute("width", "22");
              svg.setAttribute("height", "22");
              svg.setAttribute("aria-hidden", "true");
              svg.setAttribute("focusable", "false");
            }}
            data-inactive={index >= schwierigkeitsgrad ? "true" : "false"}
          />
        ))}
      </div>
      <div className={`${styles["cooking-information"]}`}>
        {completeTimeJSX}
        {cookingTimeJSX}
        {prepareTimeJSX}
        {bakingTimeJSX}
        {coolingTimeJSX}
        {restingTimeJSX}
        {freezingTimeJSX}
      </div>
    </section>
  );
}

export default RecipeDifficultyInfo;
